import { SDrawerOrModal, SGeneralForms, SLocalTreeSelected } from 'shj-components'
import React, { useEffect } from 'react'
import { Button, Form, Input, message, Select, TreeSelect } from 'antd'
import { httpOrgList } from '@/services/homeService.ts'
import {
  generalStandardSaveBatchListV2,
  generalStandardUpdateById, getGeneralPage,
  getProductCommonPage,
  getSkuPageList,
} from '@/services/product.ts'
import { debounce, isEmpty } from 'lodash-es'
import { useSetState } from 'ahooks'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import dayjs from 'dayjs'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { replaceRule } from "@/utils/data.ts";

type IProps = {
  record: Record<string, any>
  onClose: () => void
  onReload: () => void
  open: boolean
}

export const AddOrEditStandard = (props: IProps) => {
  const {open, record, onClose, onReload} = props;
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    initValues: {},
    companyList: [],
    productList: [],
    budgetRule: '',
    searchValue: '',
    loading: false,
    generalId: '',
    productId: '',
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  useEffect(() => {
    getOptions()
    if (!isEmpty(props.record)) {
      const { orgIdList: shops, budgetRule } = props.record.standardJson || {}
      const obj = {
        ...props.record,
        // editFlag:  props.record.editFlag,
        shops: shops?.map(item => item.id) || [],
        budgetRule: budgetRule,
        startDate: dayjs(props.record.startDate),
        endDate: props.record.endDate && dayjs(props.record.endDate),
        applyProdIdList: [props?.record?.applyProdId],
      }
      setRuleModal({ value: budgetRule })
      form?.setFieldsValue(obj)
      setState({ initValues: { ...obj, shops }, generalId: props.record?.genItemId })
    }
  }, [props.record])

  useEffect(() => {
    getProduct(state.searchValue)
  }, [state.searchValue])

  const getProduct = debounce(async (nameKey?) => {
    const data: any = await getSkuPageList({
      pageId: 1,
      pageSize: 10,
      data: {
        skuNameKey: '', //sku名称检索
        busType: 'prod', //必传-对应产品还是打包模版的sku，该处默认传-prod
      },
    })
    setState({
      productList:
        data?.list.map(el => {
          return { skuName: el.id + '_' + el.skuName, id: el.id }
        }) || [],
    })
  }, 500)

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    setState({ companyList })
  }

  const getShopArr = codeArr => {
    return [{ id: '0', name: '通用' }, ...state.companyList]?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, name: item.name })
      return res
    }, [])
  }

  const onSelectProduct = ({ value }) => {
    if(!record.id) {
      const productIds = form.getFieldValue('applyProdIdList')
      if(value === '0'){
        form.setFieldsValue({applyProdIdList: ['0']})
      } else {
        form.setFieldsValue({applyProdIdList: productIds.filter(productId => productId !== '0')})
      }
    } else {
      setState({ productId: value })
      form.setFieldValue('applyProdIdList', value)
    }
  }

  const onFinish = () => {
    form.validateFields()
      .then(values => {
        setState({ loading: true })
        const orgIdList = values.orgIdList ? getShopArr(values.orgIdList) : []
        const values_ = {
          ...values,
          standardJson: { orgIdList: orgIdList, budgetRule: ruleModal.value },
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
          applyProdId: props.record.applyProdId ? props.record.applyProdId : null,
        }
        const apiUrl = values_.id ? generalStandardUpdateById : generalStandardSaveBatchListV2
        apiUrl(values_)
          .then((res: any) => {
            message.success(res.message || '操作成功')
            onReload()
            onClose()
          })
          .catch(() => {
            setState({ loading: false })
          })
          .finally(() => {
            setState({ loading: false })
          })
      })
  }

  return (
    <SDrawerOrModal
      title={(record?.id ? '编辑' : '新增') + '标配'}
      width={600}
      open={open}
      onOk={onFinish}
      loading={state.loading}
      onCancel={onClose}
    >
      <SGeneralForms
        formConfig={{form}}
        isHideGobackBtn={true}
        initialValues={
          props.record.id
            ? {}
            : { requiredFlag: false, editFlag: false, applyProdIdList: ['0'], orgIdList: ['0'] }
        }
        layout={'vertical'}
        titleMode={'edit'}
        configs={[
          {
            title: '基础信息',
            formItem: [
              { name: 'id', hidden: true },
              { name: 'key', hidden: true },
              {
                name: 'genItemId',
                label: '所属通项',
                required: true,
                rules: [{ required: true, message: '所属通项不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSelect
                    allowClear
                    label={'所属通项'}
                    style={{ width: '100%' }}
                    fixedParams={{ sonChooseType: 'GEN_STANDARD' }}
                    nameKey={'itemNameKey'}
                    query={ state.generalId ? { id: state.generalId } : {}}
                    fetchOptions={getGeneralPage}
                    fieldNames={{ label: 'itemName', value: 'id' }}
                    disabled={props.record?.id}
                  />
                )
              },
              {
                name: 'requiredFlag',
                label: '是否必选',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'productSkuId',
                label: '选择产品SKU',
                required: true,
                rules: [{ required: true, message: '产品SKU不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSearchSelect
                    fetchOptions={getSkuPageList}
                    label={'产品SKU'}
                    nameKey={'keyword'}
                    disabled={props.record?.id}
                    fixedParams={{
                      prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'],
                    }}
                    fieldNames={{ label: 'showName', value: 'id' }}
                    query={{ id: state.initValues.productSkuId }}
                  />
                ),
              },
            ],
          },
          {
            title: '预算量规则',
            titleMode: 'drawer',
            formItem: [
              {
                label: '预算量规则',
                spanCol: 24,
                name: 'budgetRule',
                children: (<div>
                  <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                  {ruleModal?.value && (
                    <Input.TextArea
                      autoSize={{ minRows: 1, maxRows: 4 }}
                      disabled
                      style={{ marginTop: 6 }}
                      value={replaceRule(ruleModal.value)}
                    />
                  )}
                </div>)
              },
              {
                name: 'editFlag',
                label: '是否可编辑量',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '适用渠道',
            titleMode: 'drawer',
            formItem: [
              {
                spanCol: 24,
                label: '适用产品',
                name: 'applyProdIdList',
                required: true,
                // isDeps: true,
                // deps: () => !props.record?.id,
                rules: [{ required: true, message: '适用产品不能为空' }],
                children: (
                  <DebounceSelect
                    disabled={props.record?.id}
                    allowClear
                    label={'产品'}
                    isCommon={true}
                    mode={'multiple'}
                    fixedParams={{ prodType: 'PRODUCT_PACKAGE' }}
                    fetchOptions={getProductCommonPage}
                    onSelect={onSelectProduct}
                    onChange={(v) => {
                      setState({productId: v})
                    }}
                    fieldNames={{ label: 'prodName', value: 'id' }}
                    query={(record.id && state.initValues.applyProdId) ? {id: state.initValues.applyProdId} : {}}
                  />
                ),
              },
              {
                name: props.record?.id ? 'orgId' : 'orgIdList',
                label: '适用门店',
                spanCol: 24,
                required: true,
                children:
                  <SLocalTreeSelected
                    treeCheckable
                    disabled={props.record?.id}
                    treeDefaultExpandAll
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    fieldNames={{ label: 'name', value: 'id' }}
                    treeData={[{ name: '通用', id: '0' }, ...state.companyList]}
                    onSelect={ (v) => {
                      const shops = form.getFieldValue('orgIdList')
                      if(v === '0'){
                        form.setFieldsValue({orgIdList: ['0']})
                      } else {
                        form.setFieldsValue({orgIdList: shops.filter(shop => shop !== '0')})
                      }
                    }}
                  />
              },
              {
                spanCol: 24,
                label: '开始日期',
                name: 'startDate',
                required: true,
                rules: [{ required: true, message: '开始日期不能为空' }],
                type: 'date',
              },
              {
                spanCol: 24,
                label: '结束日期',
                name: 'endDate',
                type: 'date',
                comConfig: {
                  disabledDate: current => {
                    const startDate = form.getFieldValue('startDate')
                    if (startDate) return current && current < dayjs(startDate).endOf('day')
                  },
                },
              },
            ],
          },
        ]}
      />
      <RulesModal
        modalProps={{ ...ruleModal }}
        onCancel={() => setRuleModal({ open: false })}
        type={'generalBudgetItem'}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </SDrawerOrModal>
  )
}
